import styled from "styled-components";
import {styledByDevice} from "../../../themes/architecture/styled-by-device";
import {LobbyHeaderMobileBox, LobbyHeaderPCBox} from "./lobby-header.default.box";

const PCBox = styled(LobbyHeaderPCBox)`
  padding-bottom: 0;
  background-image: url(${props => props.theme.images.texture.toString()});
`;

const MobileBox = styled(LobbyHeaderMobileBox)`
  background-image: url(${props => props.theme.images.texture.toString()});
`;

export const LobbyHeaderCasino777Box = styledByDevice(PCBox, MobileBox);